import { Image } from 'antd';
import Page from '../../components/page';
import ActionHeader from '../../components/actionHeader';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const Flow = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Page
      header={
        <ActionHeader
          title={t('flow_coming_soon')}
          showBack
          onBack={() => navigate(-1)}
        />
      }
    >
      <Image src="/flow.png" preview={false} style={{ width: '100%' }} />
    </Page>
  );
};

export default Flow;
